function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var borders = {};

var breakpoints = ['320px', '640px', '1024px', '1280px', '1680px'];
// @media screen and (min-width: 320px)
// @media screen and (min-width: 640px)
// @media screen and (min-width: 1024px)
// @media screen and (min-width: 1280px)
// @media screen and (min-width: 1680px)

// aliases
breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];
breakpoints['2xl'] = breakpoints[4];

var colors = {
  transparent: 'transparent',
  current: 'currentColor',
  'red:100': '#6e0002',
  'red:90': '#9d0003',
  'red:80': '#b80003',
  'red:70': '#d71920',
  'red:60': '#e52630',
  'red:50': '#f24c4f',
  'red:40': '#f46f71',
  'red:30': '#fd999a',
  'red:20': '#fcc3c4',
  'red:10': '#fee1e2',
  'magenta:100': '#750037',
  'magenta:90': '#960043',
  'magenta:80': '#b3004c',
  'magenta:70': '#ca0455',
  'magenta:60': '#dc1d68',
  'magenta:50': '#e94181',
  'magenta:40': '#f36fa0',
  'magenta:30': '#f9a0c1',
  'magenta:20': '#fcc3d8',
  'magenta:10': '#fee1ec',
  'purple:100': '#460086',
  'purple:90': '#5300a5',
  'purple:80': '#6304ca',
  'purple:70': '#771ddc',
  'purple:60': '#8f41e9',
  'purple:50': '#ab6ff3',
  'purple:40': '#bb89f6',
  'purple:30': '#cca6f9',
  'purple:20': '#ddc3fc',
  'purple:10': '#eee1fe',
  'blue:100': '#002a7e',
  'blue:90': '#00349d',
  'blue:80': '#003db8',
  'blue:70': '#0547cd',
  'blue:60': '#1e5ede',
  'blue:50': '#578aef',
  'blue:40': '#6f9bf4',
  'blue:30': '#95b7fc',
  'blue:20': '#c3d6fc',
  'blue:10': '#e1ebfe',
  'green:100': '#003011',
  'green:90': '#00461a',
  'green:80': '#005c24',
  'green:70': '#00712e',
  'green:60': '#008539',
  'green:50': '#00a94f',
  'green:40': '#04c45a',
  'green:30': '#40e884',
  'green:20': '#89f6b2',
  'green:10': '#c3fcd8',
  'teal:100': '#004034',
  'teal:90': '#005242',
  'teal:80': '#006451',
  'teal:70': '#00755f',
  'teal:60': '#00866c',
  'teal:50': '#00a584',
  'teal:40': '#04caa1',
  'teal:30': '#41e9c5',
  'teal:20': '#89f6df',
  'teal:10': '#c3fcf0',
  'cyan:100': '#003664',
  'cyan:90': '#004575',
  'cyan:80': '#005486',
  'cyan:70': '#006496',
  'cyan:60': '#0075a5',
  'cyan:50': '#0095bf',
  'cyan:40': '#10b4d3',
  'cyan:30': '#41d8e9',
  'cyan:20': '#89f0f6',
  'cyan:10': '#c3f9fc',
  'gray:100': '#151515',
  'gray:90': '#212121',
  'gray:80': '#303030',
  'gray:70': '#424242',
  'gray:60': '#5e5e5e',
  'gray:50': '#8a8a8a',
  'gray:40': '#adadad',
  'gray:30': '#c9c9c9',
  'gray:20': '#e0e0e0',
  'gray:10': '#f2f2f2',
  'orange:50': '#ff7633',
  'yellow:50': '#faba2a',
  'white:emphasis': 'rgba(255, 255, 255, 1.0)',
  'white:primary': 'rgba(255, 255, 255, .92)',
  'white:secondary': 'rgba(255, 255, 255, .60)',
  'white:tertiary': 'rgba(255, 255, 255, .47)',
  'white:disabled': 'rgba(255, 255, 255, .28)',
  'black:emphasis': 'rgba(0, 0, 0, 1.0)',
  'black:primary': 'rgba(0, 0, 0, .92)',
  'black:secondary': 'rgba(0, 0, 0, .65)',
  'black:tertiary': 'rgba(0, 0, 0, .54)',
  'black:disabled': 'rgba(0, 0, 0, .30)'
};

/**
 * A generic font family should be the last item in the list of font family names:
 * - serif
 * - sans-serif
 * - monospace
 * - cursive
 * - fantasy
 * - system-ui
 * - math
 * - emoji
 * - fangsong
 */
var fonts = {
  base: '"Segoe UI", -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica, Arial, sans-serif',
  mono: '"Segoe UI Mono", "SFMono-Medium", "SF Mono", Menlo, Consolas, Courier, monospace'
};

var fontSizes = {};

var fontWeights = {
  thin: 100,
  extralight: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};

var letterSpacings = {};

var lineHeights = {
  normal: 'normal',
  base: '1.5'
};

var outlines = {};

var radii = {
  circle: '50%',
  none: 0
};

var shadows = {
  none: 'none'
};

var sizes = {};

var space = {};

var zIndices = {
  hide: -1,
  auto: 'auto',
  base: 0,
  dropdown: 1000,
  sticky: 1100,
  fixed: 1200,
  overlay: 1300,
  drawer: 1400,
  modal: 1500,
  popover: 1600,
  toast: 1700,
  tooltip: 1800
};

var definition = {
  px: {
    quarter: {
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      notation: 'q',
      value: 1
    },
    half: {
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      notation: 'h',
      value: 2
    },
    whole: {
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 24, 32, 40, 48, 56, 64],
      notation: 'x',
      value: 4
    }
  },
  rem: {
    quarter: {
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      notation: 'q',
      value: 0.0625
    },
    half: {
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      notation: 'h',
      value: 0.125
    },
    whole: {
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 24, 32, 40, 48, 56, 64],
      notation: 'x',
      value: 0.25
    }
  }
};
var getUnitTokens = function getUnitTokens(unit) {
  var _px$rem$unit;
  var config = (_px$rem$unit = {
    'px': definition.px,
    'rem': definition.rem
  }[unit]) !== null && _px$rem$unit !== void 0 ? _px$rem$unit : {};
  var accumulatedResult = {};
  Object.keys(config).forEach(function (key) {
    var _config$key = _objectSpread2({}, config[key]),
      list = _config$key.list,
      notation = _config$key.notation,
      value = _config$key.value;
    var reducer = function reducer(acc, n) {
      var k = "".concat(n).concat(notation);
      var v = "".concat(value * n).concat(unit).replace(/^0+/, ''); // omitting leading '0's
      acc[k] = v;
      return acc;
    };
    var initialValue = {};
    accumulatedResult = _objectSpread2(_objectSpread2({}, accumulatedResult), list.reduce(reducer, initialValue));
  });
  return accumulatedResult;
};

var _rem = function _rem(theme) {
  var unitTokens = getUnitTokens('rem');
  var _theme = _objectSpread2({}, theme);
  _theme.borders = _objectSpread2(_objectSpread2({}, _theme.borders), {}, {
    1: '.0625rem solid',
    2: '.125rem solid',
    3: '.1875rem solid',
    4: '.25rem solid',
    5: '.3125rem solid'
  });
  _theme.fontSizes = _objectSpread2(_objectSpread2({}, _theme.fontSizes), {}, {
    xs: '.75rem',
    sm: '.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.75rem',
    '4xl': '2rem'
  });
  _theme.lineHeights = _objectSpread2(_objectSpread2({}, _theme.lineHeights), {}, {
    xs: '1.125rem',
    sm: '1.25rem',
    md: '1.375rem',
    lg: '1.5rem',
    xl: '1.75rem',
    '2xl': '2rem',
    '3xl': '2.25rem',
    '4xl': '2.5rem'
  });
  _theme.outlines = _objectSpread2(_objectSpread2({}, _theme.outlines), {}, {
    1: '.0625rem solid',
    2: '.125rem solid',
    3: '.1875rem solid',
    4: '.25rem solid',
    5: '.3125rem solid'
  });
  _theme.radii = _objectSpread2(_objectSpread2({}, _theme.radii), {}, {
    sm: '.1875rem',
    md: '.375rem',
    lg: '.75rem'
  });
  _theme.sizes = _objectSpread2(_objectSpread2({}, _theme.sizes), unitTokens);
  _theme.space = _objectSpread2(_objectSpread2({}, _theme.space), unitTokens);
  return _theme;
};
var _px = function _px(theme) {
  var unitTokens = getUnitTokens('px');
  var _theme = _objectSpread2({}, theme);
  _theme.borders = _objectSpread2(_objectSpread2({}, _theme.borders), {}, {
    1: '1px solid',
    2: '2px solid',
    3: '3px solid',
    4: '4px solid',
    5: '5px solid'
  });
  _theme.fontSizes = _objectSpread2(_objectSpread2({}, _theme.fontSizes), {}, {
    xs: '12px',
    sm: '14px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '28px',
    '4xl': '32px'
  });
  _theme.lineHeights = _objectSpread2(_objectSpread2({}, _theme.lineHeights), {}, {
    xs: '18px',
    sm: '20px',
    md: '22px',
    lg: '24px',
    xl: '28px',
    '2xl': '32px',
    '3xl': '36px',
    '4xl': '40px'
  });
  _theme.outlines = _objectSpread2(_objectSpread2({}, _theme.outlines), {}, {
    1: '1px solid',
    2: '2px solid',
    3: '3px solid',
    4: '4px solid',
    5: '5px solid'
  });
  _theme.radii = _objectSpread2(_objectSpread2({}, _theme.radii), {}, {
    sm: '3px',
    md: '6px',
    lg: '12px'
  });
  _theme.sizes = _objectSpread2(_objectSpread2({}, _theme.sizes), unitTokens);
  _theme.space = _objectSpread2(_objectSpread2({}, _theme.space), unitTokens);
  return _theme;
};
var createTheme = function createTheme(unit) {
  var _rem$px$unit;
  var foundation = {
    borders: borders,
    breakpoints: breakpoints,
    colors: colors,
    fonts: fonts,
    fontSizes: fontSizes,
    fontWeights: fontWeights,
    letterSpacings: letterSpacings,
    lineHeights: lineHeights,
    outlines: outlines,
    radii: radii,
    shadows: shadows,
    sizes: sizes,
    space: space,
    zIndices: zIndices
  };
  var theme = (_rem$px$unit = {
    'rem': _rem(foundation),
    'px': _px(foundation)
  }[unit]) !== null && _rem$px$unit !== void 0 ? _rem$px$unit : foundation;
  return theme;
};

var theme = createTheme('rem');

export { createTheme, theme as default };
